export function farloUiCreativesCarousel(element) {
    const carouselElement = document.querySelector('.site-creative-team');
    if (carouselElement) {
        // Step 1: Clean Up Pre-existing Flickity Classes
        carouselElement.classList.remove('flickity-enabled', 'is-draggable');

        // Step 2: Remove 'is-selected' from all cells
        const cells = carouselElement.querySelectorAll('.flickity-cell');
        cells.forEach(cell => cell.classList.remove('is-selected'));

        // Step 3: Define Media Query
        const mediaQuery = window.matchMedia('(max-width: 980px)');

        let flkty = null; // Flickity instance

        // Step 4: Initialize Flickity after Images Load
        imagesLoaded(carouselElement, () => {
            console.log('All images loaded. Initializing Flickity if applicable.');
            handleResize();
        });

        // Step 5: Handle Window Resize with Debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                console.log('Handling resize.');
                handleResize();
            }, 150);
        });

        // Function to Initialize Flickity
        function initializeFlickity() {
            if (mediaQuery.matches && !flkty) {
                flkty = new Flickity(carouselElement, {
                    cellAlign: 'center',
                    pageDots: true,
                    prevNextButtons: true,
                    wrapAround: true,
                    groupCells: true,
                    freeScroll: true,
                    draggable: true,
                    scrollSnap: true,
                    adaptiveHeight: true, // Adjust height based on selected cell
                    // Add other necessary options here
                });

                console.log('Flickity initialized.');

                // Listen to Flickity events for debugging
                flkty.on('ready', () => {
                    console.log('Flickity ready event fired.');
                    flkty.resize();
                });

                flkty.on('select', (index) => {
                    console.log('Selected slide:', index);
                });

                flkty.on('resize', () => {
                    console.log('Flickity resize event fired.');
                });

                // Force Flickity to recalculate layout after a short delay
                setTimeout(() => {
                    console.log('Forcing Flickity to resize after delay.');
                    flkty.resize();
                }, 100); // Adjust the delay as necessary
            }
        }

        // Function to Destroy Flickity
        function destroyFlickity() {
            if (flkty) {
                flkty.destroy();
                flkty = null;
                console.log('Flickity destroyed.');
            }
        }

        // Function to Handle Resize and Initialize/Destroy Flickity Accordingly
        function handleResize() {
            if (mediaQuery.matches) {
                initializeFlickity();
            } else {
                destroyFlickity();
            }
        }
    }
}
